import {
  detectionIcons,
  sidebarIcons,
} from "../../../stack/environment/icons/iconExport";
import { IntegrationsMapping } from "../../../stack/integrations/IntegrationsMapping";

export const getToolIcon = (toolName) => {
  if (!toolName) return null;
  const normalizedToolName = toolName.toLowerCase();
  const integration = IntegrationsMapping[normalizedToolName];

  if (integration) {
    return integration.newLogo || integration.logo || null;
  }
  return null;
};

export const getToolDisplayName = (toolName) => {
  if (!toolName) return null;
  const normalizedToolName = toolName.toLowerCase();
  const integration = IntegrationsMapping[normalizedToolName];
  return integration?.displayName || toolName;
};

export const getNotificationTypeDisplayName = (type) => {
  const typeDisplayMap = {
    high_risk_gap: {
      displayName: "High risk gap found",
      iconPlaceholder: sidebarIcons.ControlsIcon,
    },
    detection: {
      displayName: "Threat activity detected",
      iconPlaceholder: detectionIcons.DetectionBlack,
    },
    new_scenario_set: {
      displayName: "Scenario detected",
      iconPlaceholder: sidebarIcons.ScenariosIcon,
    },
    high_risk_entity: {
      displayName: "Entity risk level is critical",
      iconPlaceholder: sidebarIcons.EnvironmentIcon,
    },
    escalated_gap: {
      displayName: "Gap escalated",
      iconPlaceholder: sidebarIcons.ControlsIcon,
    },
  };
  return (
    typeDisplayMap[type?.toLowerCase()] || {
      displayName: type,
      iconPlaceholder: null,
    }
  );
};
